package devxertech.com.pages.portfolio.safeDeposit


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.ZoneArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.portfolio.zone.CommonAppView
import devxertech.com.pages.portfolio.zone.CommonWebView
import devxertech.com.pages.portfolio.zone.CommonZoneAbout
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/safeDeposit")
@Composable
fun SafeDepositPage() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image = Res.Image.safe_header,
            breakpoint = breakpoint,
            headingText = "Safe Deposit",
            descriptionText = "Safe deposit is your go-to Escrow Deposit Payment App.It's the ultimate solution for securely handling financial transactions.",
            startProject = false, careerHeight = true, careerFontSize = true, heightModification = true, commonPortfolioChanges = true
        )
        ZoneArrow("SafeDeposit", largeTitle = true)
        CommonZoneAbout(image = Res.Image.safe_icon, title = "SafeDeposit",
            description = "Safedeposit is your go-to Escrow Deposit Payment App, available for both Android and iOS. It's the ultimate solution for securely handling financial transactions.")
        CommonAppView(image = Res.Image.safe_png, breakpoint)
        CommonWebView(image = Res.Image.safe_webview, breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}